import { H2Span } from "@constellation-academy/epic-ui";
import React, { useCallback } from "react";
import { useRefetchableFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { dispatchExclusions_MessageDispatchFragment$key } from "@relay/dispatchExclusions_MessageDispatchFragment.graphql";
import { dispatchExclusions_Refetch } from "@relay/dispatchExclusions_Refetch.graphql";

import { MESSAGE_DISPATCH_FRAGMENT } from "./dispatch-exclusions.graphql";
import { DispatchExclusionsProps } from "./dispatch-exclusions.types";
import { DispatchConditionDropdown } from "../dispatch-condition-dropdown";
import { DispatchConditionPreview } from "../dispatch-conditions-preview";

export const DispatchExclusions = ({ messageDispatchFragmentRef }: DispatchExclusionsProps) => {
	const { t } = useTranslation("common");
	const [messageDispatch, refetch] = useRefetchableFragment<
		dispatchExclusions_Refetch,
		dispatchExclusions_MessageDispatchFragment$key
	>(MESSAGE_DISPATCH_FRAGMENT, messageDispatchFragmentRef ?? null);

	const refresh = useCallback(() => {
		refetch({}, { fetchPolicy: "network-only" });
	}, [refetch]);

	return (
		<>
			<H2Span>{t("messageDispatch.exclusions")}</H2Span>
			<DispatchConditionDropdown
				isInclusion={false}
				messageDispatchFragmentRef={messageDispatch}
				onChange={refresh}
			/>
			<DispatchConditionPreview
				messageDispatchFragmentRef={messageDispatch}
				onChange={refresh}
				isInclusion={false}
			/>
		</>
	);
};
